import React from 'react';
import { Navigate } from 'react-router-dom';
import { normalizeRoleKey, EXECUTIVE_ROUTE_ROLES } from '../../utils/roleCapabilities';

// Picks a sensible "home" page for the current user based on role. Used by
// the SPA catch-all so unknown URLs land on something appropriate for the
// role (rather than always /employee/dashboard, which renders 403 for
// management roles).
export default function RoleHomeRedirect() {
  const token = typeof localStorage !== 'undefined' ? localStorage.getItem('access_token') : null;
  if (!token) return <Navigate to="/login" replace />;

  const role = normalizeRoleKey(localStorage.getItem('role'));
  const isPlatformAdmin = localStorage.getItem('is_platform_admin') === '1';

  if (isPlatformAdmin) return <Navigate to="/super-admin/dashboard" replace />;
  if (role === 'hr_admin') return <Navigate to="/admin/dashboard" replace />;
  if (role === 'ceo') return <Navigate to="/ceo/dashboard" replace />;
  if (EXECUTIVE_ROUTE_ROLES.includes(role)) return <Navigate to="/ceo/dashboard" replace />;
  if (
    role === 'manager' ||
    role === 'hod' ||
    role === 'operation_manager' ||
    role === 'finance'
  ) {
    return <Navigate to="/manager/dashboard" replace />;
  }
  return <Navigate to="/employee/dashboard" replace />;
}
